import { render, staticRenderFns } from "./ARDevelopment.vue?vue&type=template&id=0a83cb39&"
import script from "./ARDevelopment.vue?vue&type=script&lang=js&"
export * from "./ARDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports